<template>
  <!-- 抽奖记录 -->
  <div class="lotteryUser">
    <swiper v-if="awardList.length > 0" :options="swiperOption" class="myluck_swiper">
      <swiper-slide v-for="(item, index) in awardList" :key="index" class="swiper">
        <div class="lotteryUser-news">
          <span>恭喜{{ item}}</span>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'

export default {
  name: 'bubble',
  data() {
    return {
      awardList: [],
      // swiper设置参数
      swiperOption: {
        loop: true, // 自动播放
        direction: 'vertical', // y轴方向滚动
        autoplay: {
          delay: 1000,
          disableOnInteraction: false
        }, // 时间间隔
        speed: 1000,
        slidesPerView: '1' // 显示滑块数量
      }
    }
  },
  computed: {
    ...mapState([
      'sGroupId'
    ])
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    this.getLotteryUser()
  },
  methods: {
    // 获取中奖记录
    async getLotteryUser() {
      try {
        const { code, data = {}, msg } = await this.$api.getExchangeList({ sGroupId: this.sGroupId, userId: this.$xesCookie.get('stu_id') })
        if (code === 0) {
          this.awardList = data.list || []
        } else {
          this.$toast(msg || '请求错误')
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.lotteryUser {
  .myluck_swiper {
    width: 523px/2;
    height: 23px;
    padding: 0 16px;
    overflow: hidden;
    background: linear-gradient(90deg, #ffa615, #ffc445);
    border-radius: 11px;
  }

  &-news {
    height: 24px;
    overflow: hidden;
    font-size: 0;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;

    span {
      font-size: 12px;
      font-family: PingFang SC;
      vertical-align: middle;
      color: #fff;
    }
  }
}
</style>
